import React, { Component } from 'react';
import List from './List';
import Form from './Form';
import TabbablePage from '../../components/TabbablePage';
import DocumentTitle from 'react-document-title';

export default class Page extends React.Component {
	render() {
		return (
			<DocumentTitle title="Šablony dokumentů">
				<TabbablePage
					module="template"
					List={List}
					Form={Form}
					newTitle="Nová"
					disableAdd
					listTitle="Šablony dokumentů"
					{...this.props}
				/>
			</DocumentTitle>
		);
	}
}



// WEBPACK FOOTER //
// ./src/containers/Template/Page.js